import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import { TermsList } from "../../components/TermsList";
import { ReactComponent as TickGraphic } from "../../images/tick-graphic.svg";
import Layout from '../../components/Layout';

const StyledGrid = styled(Grid)`
  margin: 0px 10px;
  color: #9e4db6;
  font-size: 36px;
  font-weight: 300;
  text-align: center;
  display: flex;
  align-items: center;
`;

const StyledTypography = styled(Typography)`
  margin: 10px 0;
  font-weight: 300;
  font-family: 'Montserrat';
`;

export const Terms = () => (
  <Layout>
    <StyledGrid container spacing={2}>
      <Grid item xs={2}>
        <TickGraphic />
      </Grid>
      <Grid item xs={10}>
        Giving your consent to our Terms and Conditions
      </Grid>   
    </StyledGrid>
    <StyledTypography>
      Manage your acceptance of the LMS Terms and Conditions and terms for specific products.
    </StyledTypography>
    <StyledTypography>
      If your firm wishes to use APIs to access our software and services, either directly or through an integrator, please contact us at <a href="mailto:ProductTeam@lms.com?subject=API Access">ProductTeam@lms.com</a> to find out more. Access to APIs will be reviewed on a firm-by-firm basis.
    </StyledTypography>
    <StyledTypography>
      By choosing the ‘Consent’ option you confirm that you have read and agree to each set of terms. We are entitled to assume that the person(s) accepting the Terms has sufficient authority to bind the firm. Each document must be downloaded and read before continuing. Some terms may only be signed by a user with the Membership Manager role at your firm.
    </StyledTypography>
    <br />
    <TermsList />
    <StyledTypography>
    * On behalf of my organisation
    </StyledTypography>
  </Layout>
);